import React, {useContext, useState, useEffect, useMemo} from 'react';

import Ad from '~/src/components/ad/Ad';

import {AdFormat} from '~/src/utilities/constants/formats';
import {getAdUnitName, showAd} from '~/src/utilities/helpers/ad';
import {getNextCounter} from '~/src/utilities/helpers/counters';
import {SectionContext} from '~/src/components/context/SectionContext';
import {slugify} from '~/src/utilities/helpers/string';

const getQuarterPosBase = ({subtype, fullUrlPath}) => (subtype === 'category' ? `inside-quarter-${slugify(fullUrlPath)}` : `inside-quarter`);
const getFullPosBase = ({subtype, fullUrlPath}) => (subtype === 'category' ? `inside-full-${slugify(fullUrlPath)}` : `inside-full`);

const TeaserAd = (props) => {
    const section = useContext(SectionContext);
    const [renderAd, setRenderAd] = useState(false);

    const ad = useMemo(() => {
        if (renderAd) {
            if (props.adUnitName) {
                return props;
            }

            const isQuarterPos = props.format.primaryGrid === AdFormat.INSIDE_QUARTER_POS;
            const adBase = isQuarterPos ? getQuarterPosBase(section) : getFullPosBase(section);

            return {
                ...props,
                adUnitName: getAdUnitName(adBase, getNextCounter(adBase)),
                format: {
                    ...props.format,
                    primaryGrid: isQuarterPos ? AdFormat.INSIDE_QUARTER_POS : AdFormat.INSIDE_FULL_POS
                }
            };
        }
    }, [props.adUnitName, renderAd]);

    process.browser &&
        useEffect(() => {
            setRenderAd(!props.availableFor || showAd(props.availableFor));
        }, []);

    if (!ad) {
        return null;
    }

    return <Ad {...ad} format={ad.format.primaryGrid} colorScheme={ad.format.colorScheme} />;
};

export default TeaserAd;
